import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../../_metronic/helpers'
import {Category, CategoryQueryResponse} from './_models'
import {getToken} from '../../../../auth/core/AuthHelpers'

const API_URL = process.env.REACT_APP_API_URLS
 

const getCategory = (query: string): Promise<CategoryQueryResponse> => {
  return axios
    .get(`${API_URL}/plan/categoryIndex/query?${query}`)
    .then((d: AxiosResponse<CategoryQueryResponse>) => {
      console.log("ddsds",d.data);
      
      return d.data
    })
}

const deleteCategoryById = (id: any) => {
  return axios
    .put(`${API_URL}/plan/category/delete/${id}`, getToken())

    .then((response: any) => response.data)
}

const createCategoryMaster = (data: any) => {
  
  return axios
    .post(`${API_URL}/plan/category/add`, data, getToken())
    .then((response: any) => response.data)
}

const updateCategoryMaster = (data: any,id:any) => {
  return axios
    .put(`${API_URL}/plan/category/update/${id}`,  data, getToken())
    .then((response: any) => {
      
      return response.data
    })
} 
export {
  getCategory,
  createCategoryMaster,
  deleteCategoryById,
  updateCategoryMaster,
}
